// extracted by mini-css-extract-plugin
export var option = "_bx-0";
export var optionCard = "_bx-f";
export var optionContent = "_bx-g";
export var optionIcon = "_bx-i";
export var optionIconBox = "_bx-h";
export var optionLabel = "_bx-j";
export var optionPill = "_bx-m";
export var optionPillBadge = "_bx-p";
export var optionPillIcon = "_bx-n";
export var optionPillLabel = "_bx-o";
export var optionRadio = "_bx-k";
export var optionRadioInner = "_bx-l";
export var optionReveal = "_bx-2";
export var optionRevealDelay0 = "_bx-3";
export var optionRevealDelay1 = "_bx-4";
export var optionRevealDelay10 = "_bx-d";
export var optionRevealDelay11 = "_bx-e";
export var optionRevealDelay2 = "_bx-5";
export var optionRevealDelay3 = "_bx-6";
export var optionRevealDelay4 = "_bx-7";
export var optionRevealDelay5 = "_bx-8";
export var optionRevealDelay6 = "_bx-9";
export var optionRevealDelay7 = "_bx-a";
export var optionRevealDelay8 = "_bx-b";
export var optionRevealDelay9 = "_bx-c";
export var optionSelected = "_bx-1";